import React from "react";
import classes from "./blogsListPage.module.css";
import { BlogsFilterPage } from "./blogsFilter/BlogsFilterPage";
import { useSelector } from "react-redux";
import { selectBlogFilter } from "../../store/blog/blogFilterSlice";
import {
  selectAllBlogs,
  useGetBlogListQuery,
} from "../../services/blog/blogApiSlice";
import { CategoryPageSkeleton } from "../../component/skeleton/CategoryPageSkeleton";
import { BlogsTablePage } from "./blogsTable/BlogsTablePage";

export const BlogsListPage = () => {
  const filters = useSelector(selectBlogFilter);

  const { isLoading, isSuccess } = useGetBlogListQuery(filters);
  const blogList = useSelector((state) => selectAllBlogs(state, filters));

  return isSuccess ? (
    <div className={classes.box}>
      <BlogsFilterPage />
      <BlogsTablePage data={blogList} />
    </div>
  ) : (
    <CategoryPageSkeleton />
  );
};
